/* eslint-disable react/jsx-indent */
import * as React from "react";
import { Grid, Typography, makeStyles } from "@material-ui/core";
import Image from "next/image";
import Link from "next/link";
import { Fade } from "react-awesome-reveal";

import { getApiService } from "../../../../../services/AgapeAPI";
import AgapeSlider from "../../../../common/slider/AgapeSlider";

const useStyles = makeStyles((theme) => ({
  container: {
    width: "100%",
    marginTop: 60,
    [theme.breakpoints.down("md")]: {
      marginTop: 40,
    },
  },
  image: {
    borderRadius: "10px",
  },
  title: {
    fontWeight: "bold",
    fontSize: "18px",
    color: "#292929",
    marginBottom: "-20px",
  },
}));

const GiftCarts = ({ giftCarts, data }) => {
  const classes = useStyles();

  const sliderTypeHandler = (jsxSlider, link) => {
    return (
      <>
        {!link || link === "" ? (
          jsxSlider
        ) : (
          <>
            {link?.indexOf("http") === 0 ? (
              <a href={link} target="_blank" rel="noreferrer">
                {jsxSlider}
              </a>
            ) : (
              <Link href={link}>
                <a>{jsxSlider}</a>
              </Link>
            )}
          </>
        )}
      </>
    );
  };

  return (
    <Grid container className={classes.container} alignItems="center">
      <Grid item xs={12}>
        <Typography variant="h2" className={classes.title}>
          خرید کارت هدیه
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <AgapeSlider
          listLength={giftCarts.length}
          slidesToShowDesktop={4}
          slidesToShowTablet={3}
          slidesToShowMobile={2}
          arrow
          autoplay
          infinite
        >
          {giftCarts.map((item, i) => (
            <div className={classes.div} key={item.name}>
              {item.banner &&
                data &&
                data.slug &&
                sliderTypeHandler(
                  <Fade triggerOnce delay={(i + 1) * 500}>
                    <Image
                      src={item.banner}
                      placeholder="blur"
                      blurDataURL={item.banner}
                      alt={item.name}
                      width={1}
                      height={1}
                      layout="responsive"
                      className={classes.image}
                    />
                  </Fade>,
                  `/gift-cards/${data.slug}?cat=${item.name}`
                )}
            </div>
          ))}
        </AgapeSlider>
      </Grid>
    </Grid>
  );
};

export default GiftCarts;
